<template>
  <transition name="wsf-modal-fade" v-if="showModal">
    <div class="wsf-modal-backdrop">
      <div class="wsf-modal" role="dialog">
        <div class="wsf-modal__close">
          <button type="button"
                  class="btn-close"
                  @click="closeModal"
                  aria-label="Close modal">
            <slot v-if="$slots.closeIcon" name="closeIcon" />
            <span v-else>×</span>
          </button>
        </div>
        <div>
          <template>
            <iframe :src="channelAdvisorUrl"
                    title="Channel advisor variant"
                    style="border:0"></iframe>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import { eventBus } from "@Foundation/eventbus/eventbus";

  export default {
    name: 'modal',
    data() {
      return {
        showModal: false,
        channelAdvisorUrl: ''
      };
    },
    mounted() {
      eventBus.$on('show-wsf-modal', (val) => {
        this.showModal = true;
        this.channelAdvisorUrl = val;
      });
    },
    destroyed() {

      window.removeEventListener("message", this.channeltagging);

    },
    methods: {
      closeModal() {

        let elements = document.getElementsByClassName('wsf-modal-backdrop')

        if (elements.length > 1) {

          for (const element of elements) { 
            element.style.display = 'none'; 
            this.showModal = false; 
          } 

        }

        else this.showModal = false;
      }
    }
    
     
 };
</script>
<style lang="scss" src="./channel-advisor-modal.scss"></style>

